<template>
  <div
    class="placeholder-box"
    :style="{border: [CHART_STATUS_TYPE__STYLE, CHART_STATUS_TYPE__EDIT].includes(type) ? '1px solid #e6e6e6' : ''}">

  </div>
</template>

<script>
  import current from "./mixin"
  import {CHART_STATUS_TYPE__STYLE, CHART_STATUS_TYPE__EDIT} from '../../types'
  export default {
    mixins: [current],
    name: "Placeholder",
    data() {
      return {
        CHART_STATUS_TYPE__STYLE,
        CHART_STATUS_TYPE__EDIT
      }
    },
    created() {

    }
  }
</script>

<style lang="less">

  .placeholder-box {
    width: 100%;
    height: 100%;
  }
</style>
